module.exports = __webpack_public_path__ + "img/201110-1.77c7b9e2.png";